'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagSnAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-9.53674e-06 9.05991e-06C9.33333 -2.44887e-05 18.6667 -2.79377e-06 28 -7.62939e-06C28 6.66666 28 13.3333 28 20C18.6667 20 9.33333 20 -2.19792e-07 20L-9.53674e-06 9.05991e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.3333 5.84126e-06L28 -7.62939e-06V20H13.3333V5.84126e-06Z",
          fill: "#F13642"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-2.19792e-07 20H9.33333V5.84126e-06L-9.53674e-06 9.05991e-06L-2.19792e-07 20Z",
          fill: "#17A052"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.33333 20H18.6667V5.84126e-06H9.33333V20Z",
          fill: "#FFF166"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 11.3667L12.0407 12.6967L12.7002 10.4223L10.8298 8.96995L13.1967 8.89435L14 6.66667L14.8033 8.89435L17.1702 8.96995L15.2998 10.4223L15.9593 12.6967L14 11.3667Z",
          fill: "#17A052"
        }
      )
    ]
  }
);
const VpFlagSnAsset = forwardRef(FlagSnAsset);

export { VpFlagSnAsset as default };
